import React, { useState } from "react";
import products from "../../data/ProductData";
import "./Product.css";
import { whatsappNumber } from "../../constants/constants";
import brochureIcon from "../../assets/icons/downloadPdf.png";
import whatsappIcon from "../../assets/icons/Whatsapp.png";

function Products() {
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);

  const handleViewDocument = (document) => setSelectedDocument(document);
  const closeModal = () => setSelectedDocument(null);

  const categoryMap = {};
  products.forEach((product) => {
    if (!categoryMap[product.Category]) {
      categoryMap[product.Category] = new Set();
    }
    categoryMap[product.Category].add(product.Subcategory);
  });
  const categories = Object.entries(categoryMap).map(([category, subcats]) => ({
    category,
    subcategories: Array.from(subcats),
  }));

  const filteredProducts = products.filter((product) => {
    if (selectedCategory && selectedSubcategory) {
      return (
        product.Category === selectedCategory &&
        product.Subcategory === selectedSubcategory
      );
    }
    if (selectedCategory) {
      return product.Category === selectedCategory;
    }
    return true;
  });
  
  return (
    <div>
<div className="products-header">
        <h2>Products</h2>
      <nav className="product-menu">
        <ul>
          <li>
            <button
              className={!selectedCategory ? "active" : ""}
              onClick={() => {
                setSelectedCategory(null);
                setSelectedSubcategory(null);
              }}
            >
              All
            </button>
          </li>
          {categories.map(({ category, subcategories }) => (
            <li key={category} className={selectedCategory === category ? 'active-category' : ''}>
              <button
                className={
                  selectedCategory === category ? "active" : ""
                }
                onClick={() => {
                  setSelectedCategory(selectedCategory === category ? null : category);
                  setSelectedSubcategory(null);
                }}
              >
                {category}
              </button>
             {selectedCategory === category && (
              <ul>
                {subcategories.map((subcat) => (
                  <li key={subcat}>
                    <button
                      className={
                        selectedCategory === category &&
                        selectedSubcategory === subcat
                          ? "active"
                          : ""
                      }
                      onClick={() => {
                        setSelectedCategory(category);
                        setSelectedSubcategory(subcat);
                      }}
                    >
                      {subcat}
                    </button>
                  </li>
                ))}
              </ul>
            )}
            </li>
          ))}
        </ul>
      </nav>

      
      </div>

      <div className="products-container">
        {filteredProducts.map((product) => (
          <div key={product.id} className="product-card">
            <img
              src={product.logo}
              alt={product.name}
              className="product-logo"
            />
            <h2 className="product-name" title={product.name}>
              {product.name}
            </h2>
            <div className="button-container">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleViewDocument(product.document);
                }}
                className="view-document-link"
              >
                <img
                  src={brochureIcon}
                  alt="View Brochure"
                  className="buttonIcon"
                  title="View pdf"
                />
              </a>

              <a
                href={`https://wa.me/${whatsappNumber}?text=Hi, I am interested in ${product.name}.`}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-link"
              >
                <img
                  src={whatsappIcon}
                  alt="Request a Quote"
                  className="buttonIcon"
                  title="Request a Quote"
                />
              </a>
            </div>
          </div>
        ))}
      </div>
      {selectedDocument && (
        <div className="modal">
          <div className="modal-content">
            <button className="close-button" onClick={closeModal}>
              &times;
            </button>
            <iframe
              src={selectedDocument}
              title="Document Viewer"
              className="document-viewer"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
}

export default Products;
